<template>
  <div id="chart" style="width: 100%;height:90%"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'circleChart',
  data: function () {
    return {
      chart: null,
      option: {
        tooltip: {
          trigger: 'item',
          formatter: '{a}{b}: {c} ({d}%)'
        },
        grid: {
          left: 20,
          right: 100
        },
        title: {
          text: '暂无数据',
          show: false,
          left: 'center',
          top: 'center'
        },
        legend: {
          show: false, // 饼图子元素显隐功能开关
          orient: 'horizontal',
          icon: 'circle',
          left: '10',
          bottom: 0,
          data: []
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '50%'],
            avoidLabelOverlap: true,
            // label: {
            //   formatter: '{b}: {d}% '
            // },
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: []
          }
        ]
      }
    }
  },
  props: {
    data: {
      type: Array
    }
  },
  watch: {
    data: {
      handler (val) {
        if (val && val.length > 0) {
          console.log('diyici ', val)
          this.option.legend.data = this.data.map(e => e.name)
          this.option.series[0].data = this.data
          this.option.title.show = false
        } else {
          this.option.legend.data = []
          this.option.series[0].data = []
          this.option.title.show = true
        }
        this.$nextTick(() => {
          this.drawPechart()
        })
      },
      immediate: true
    }
  },
  mounted () {
    /* this.$nextTick(() => {
      this.drawPechart()
    }) */
  },
  methods: {
    drawPechart () {
      this.chart = echarts.init(document.getElementById('chart'))
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style scoped>

</style>
